import { API_URL } from "../constant"
import API from "./interceptor";

export const getAllProducts = (pageNumber = 1, pageSize = 10, sortOrder = 'ASC', searchQuery, type) => {
    const params = new URLSearchParams({
        pageNumber,
        pageSize,
        sortOrder,
        searchQuery,
        type
    });
    return API.get(`${API_URL}/api/products/list?${params.toString()}`);
};


export const getAllCategory = (pagination = true, pageNumber = 1, pageSize = 10, sortOrder = 'ASC', searchQuery) => {
    const params = new URLSearchParams({
        pageNumber,
        pageSize,
        sortOrder,
        searchQuery,
        pagination
    });
    return API.get(`${API_URL}/api/category/list?${params.toString()}`);
};

export const getProductById = (id) => {
    const productById = API.get(`${API_URL}/api/products/${id}`)
    return productById
}

export const getAffiliates = () => {
    const affiliate = API.get(`${API_URL}/api/products/get/affiliate`)
    return affiliate
}

export const getCategoryById = (id) => {
    const categoryById = API.get(`${API_URL}/api/category/${id}`)
    return categoryById
}

export const getBannerById = (id) => {
    const bannerId = API.get(`${API_URL}/api/banner/${id}`)
    return bannerId
}

export const editProductById = (id, productData) => {
    return API.put(`${API_URL}/api/products/${id}`, productData);
};


export const editCategoryById = (id, formData) => {
    return API.put(`${API_URL}/api/category/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const createOffer = (productData) => {
    return API.post(`${API_URL}/api/products/create`, productData);
};

export const deleteProductById = (id) => {
    return API.delete(`${API_URL}/api/products/${id}`);
};

export const deleteCategoryById = (id) => {
    return API.delete(`${API_URL}/api/category/${id}`);
};

export const createCategory = (formData) => {
    return API.post(`${API_URL}/api/category/create`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};
export const createBanner = (formData) => {
    return API.post(`${API_URL}/api/banner/create`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};
export const updateBanner = (id, formData) => {
    return API.put(`${API_URL}/api/banner/${id}`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const getBanners = () => {
    const banner = API.get(`${API_URL}/api/banner`,)
    return banner
}

export const deletePhotoyId = (bannerId) => {
    return API.delete(`${API_URL}/api/banner/${bannerId}/photos`);
};

export const deleteBannerById = (bannerId) => {
    return API.delete(`${API_URL}/api/banner/${bannerId}`);
};

export const sendNotification = async (
    topic = "product_updates",
    data = {}
) => {
    return await API.post(`${API_URL}/api/notifications/send-notification`, {
        topic,
        data, // this will include id, title, imageUrl
    });
};

export const sendExpiration = (offerdata) =>{
   return API.post(`${API_URL}/api/products/expire_product`,offerdata) //http://localhost:6006/api/products/expire_product
}

